'use strict';

var primitives = {
  'grass-90': 'var(--grass-90)',
  'grass-80': 'var(--grass-80)',
  'grass-75': 'var(--grass-75)',
  'grass-70': 'var(--grass-70)',
  'grass-60': 'var(--grass-60)',
  'grass-50': 'var(--grass-50)',
  'grass-40': 'var(--grass-40)',
  'grass-30': 'var(--grass-30)',
  'grass-20': 'var(--grass-20)',
  'grass-15': 'var(--grass-15)',
  'grass-10': 'var(--grass-10)',
  'grass-07': 'var(--grass-07)',
  'grass-05': 'var(--grass-05)',
  'crab-90': 'var(--crab-90)',
  'crab-80': 'var(--crab-80)',
  'crab-75': 'var(--crab-75)',
  'crab-70': 'var(--crab-70)',
  'crab-60': 'var(--crab-60)',
  'crab-50': 'var(--crab-50)',
  'crab-40': 'var(--crab-40)',
  'crab-30': 'var(--crab-30)',
  'crab-20': 'var(--crab-20)',
  'crab-15': 'var(--crab-15)',
  'crab-10': 'var(--crab-10)',
  'crab-07': 'var(--crab-07)',
  'crab-05': 'var(--crab-05)',
  'whale-90': 'var(--whale-90)',
  'whale-80': 'var(--whale-80)',
  'whale-75': 'var(--whale-75)',
  'whale-70': 'var(--whale-70)',
  'whale-60': 'var(--whale-60)',
  'whale-50': 'var(--whale-50)',
  'whale-40': 'var(--whale-40)',
  'whale-30': 'var(--whale-30)',
  'whale-20': 'var(--whale-20)',
  'whale-15': 'var(--whale-15)',
  'whale-10': 'var(--whale-10)',
  'whale-07': 'var(--whale-07)',
  'whale-05': 'var(--whale-05)',
  'chick-90': 'var(--chick-90)',
  'chick-80': 'var(--chick-80)',
  'chick-75': 'var(--chick-75)',
  'chick-70': 'var(--chick-70)',
  'chick-60': 'var(--chick-60)',
  'chick-50': 'var(--chick-50)',
  'chick-40': 'var(--chick-40)',
  'chick-35': 'var(--chick-35)',
  'chick-30': 'var(--chick-30)',
  'chick-20': 'var(--chick-20)',
  'chick-15': 'var(--chick-15)',
  'chick-10': 'var(--chick-10)',
  'chick-05': 'var(--chick-05)',
  'panda-100': 'var(--panda-100)',
  'panda-90': 'var(--panda-90)',
  'panda-85': 'var(--panda-85)',
  'panda-80': 'var(--panda-80)',
  'panda-75': 'var(--panda-75)',
  'panda-70': 'var(--panda-70)',
  'panda-65': 'var(--panda-65)',
  'panda-60': 'var(--panda-60)',
  'panda-50': 'var(--panda-50)',
  'panda-40': 'var(--panda-40)',
  'panda-35': 'var(--panda-35)',
  'panda-30': 'var(--panda-30)',
  'panda-25': 'var(--panda-25)',
  'panda-20': 'var(--panda-20)',
  'panda-15': 'var(--panda-15)',
  'panda-10': 'var(--panda-10)',
  'panda-05': 'var(--panda-05)',
  'panda-03': 'var(--panda-03)',
  'panda-white': 'var(--panda-white)',
  'turtle-90': 'var(--turtle-90)',
  'turtle-80': 'var(--turtle-80)',
  'turtle-75': 'var(--turtle-75)',
  'turtle-70': 'var(--turtle-70)',
  'turtle-60': 'var(--turtle-60)',
  'turtle-50': 'var(--turtle-50)',
  'turtle-40': 'var(--turtle-40)',
  'turtle-30': 'var(--turtle-30)',
  'turtle-20': 'var(--turtle-20)',
  'turtle-15': 'var(--turtle-15)',
  'turtle-10': 'var(--turtle-10)',
  'turtle-05': 'var(--turtle-05)',
  'sand-90': 'var(--sand-90)',
  'sand-80': 'var(--sand-80)',
  'sand-70': 'var(--sand-70)',
  'sand-60': 'var(--sand-60)',
  'sand-50': 'var(--sand-50)',
  'sand-40': 'var(--sand-40)',
  'sand-30': 'var(--sand-30)',
  'sand-20': 'var(--sand-20)',
  'sand-10': 'var(--sand-10)',
  'earth-90': 'var(--earth-90)',
  'earth-80': 'var(--earth-80)',
  'earth-70': 'var(--earth-70)',
  'earth-60': 'var(--earth-60)',
  'earth-50': 'var(--earth-50)',
  'earth-40': 'var(--earth-40)',
  'earth-30': 'var(--earth-30)',
  'earth-20': 'var(--earth-20)',
  'earth-10': 'var(--earth-10)',
  'water-90': 'var(--water-90)',
  'water-80': 'var(--water-80)',
  'water-70': 'var(--water-70)',
  'water-60': 'var(--water-60)',
  'water-50': 'var(--water-50)',
  'water-40': 'var(--water-40)',
  'water-30': 'var(--water-30)',
  'water-20': 'var(--water-20)',
  'water-10': 'var(--water-10)',
  'air-90': 'var(--air-90)',
  'air-80': 'var(--air-80)',
  'air-70': 'var(--air-70)',
  'air-60': 'var(--air-60)',
  'air-50': 'var(--air-50)',
  'air-40': 'var(--air-40)',
  'air-30': 'var(--air-30)',
  'air-20': 'var(--air-20)',
  'air-10': 'var(--air-10)',
  'wind-90': 'var(--wind-90)',
  'wind-80': 'var(--wind-80)',
  'wind-70': 'var(--wind-70)',
  'wind-60': 'var(--wind-60)',
  'wind-50': 'var(--wind-50)',
  'wind-40': 'var(--wind-40)',
  'wind-30': 'var(--wind-30)',
  'wind-20': 'var(--wind-20)',
  'wind-10': 'var(--wind-10)',
  'storm-90': 'var(--storm-90)',
  'storm-80': 'var(--storm-80)',
  'storm-70': 'var(--storm-70)',
  'storm-60': 'var(--storm-60)',
  'storm-50': 'var(--storm-50)',
  'storm-40': 'var(--storm-40)',
  'storm-30': 'var(--storm-30)',
  'storm-20': 'var(--storm-20)',
  'storm-10': 'var(--storm-10)',
  'sense-90': 'var(--sense-90)',
  'sense-80': 'var(--sense-80)',
  'sense-70': 'var(--sense-70)',
  'sense-60': 'var(--sense-60)',
  'sense-50': 'var(--sense-50)',
  'sense-40': 'var(--sense-40)',
  'sense-30': 'var(--sense-30)',
  'sense-20': 'var(--sense-20)',
  'sense-10': 'var(--sense-10)',
  'fire-90': 'var(--fire-90)',
  'fire-80': 'var(--fire-80)',
  'fire-70': 'var(--fire-70)',
  'fire-60': 'var(--fire-60)',
  'fire-50': 'var(--fire-50)',
  'fire-40': 'var(--fire-40)',
  'fire-30': 'var(--fire-30)',
  'fire-20': 'var(--fire-20)',
  'fire-10': 'var(--fire-10)'
};

exports.primitives = primitives;
